import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d99a4490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-btn flex-ter" }
const _hoisted_2 = ["src"]


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
    edit: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as { edit: boolean }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      style: {"margin-right":"4px"},
      src: `https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_${!props.edit ? 'edit' : 'check'}.svg`,
      alt: ""
    }, null, 8, _hoisted_2),
    _createTextVNode(" " + _toDisplayString(!props.edit ? _unref(t)('编辑') : _unref(t)('保存')), 1)
  ]))
}
}

})